import Vue from 'vue';
import Vuex from 'vuex';

import { saveAs } from 'file-saver';
import mapboxgl from 'mapbox-gl';
import { toPixels } from '../utils/export';
const STATE_VERSION = '0.0.1';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    count: 0,
    activities: [],
    routeColor: '#30D165',
    lineWidth: 2.5,
    activityTitle: 'My run',
    activitySubtitle: '2021.11.02',
    version: STATE_VERSION
  };
};

const getSavedState = () => {
  const savedState = JSON.parse(localStorage.getItem('state'));
  return savedState?.version === STATE_VERSION ? savedState : getDefaultState();
};

const store = new Vuex.Store({
  state: getSavedState() || getDefaultState(),

  // getters: {
  //   orderedResumeExperience(state) {}
  // },

  mutations: {
    increment(state) {
      state.count++;
    },

    addActivity(state, payload) {
      state.activities.push(payload);
    },

    removeActivity(state, id) {
      state.activities = state.activities.filter(
        (activity) => activity.id !== id
      );
    },

    resetState(state) {
      Object.assign(state, getDefaultState());
    },

    updateEventSelected(state, payload) {
      const { id, isChecked } = payload;

      const activity = state.activities.find((activity) => activity.id === id);
      activity.selected = isChecked;
    },

    setRouteColor(state, value) {
      state.routeColor = value;
    },

    setLineWidth(state, value) {
      state.lineWidth = value;
    },

    setActivityTitle(state, value) {
      state.activityTitle = value;
    },

    setActivitySubtitle(state, value) {
      state.activitySubtitle = value;
    }
  },

  getters: {
    activities(state) {
      return state.activities;
    },

    selectedActivities(state) {
      return state.activities.filter((activity) => activity.selected);
    },

    isSampleRunAdded(state) {
      return state.activities.some(
        (activity) => activity.name === 'sample run'
      );
    },

    routeColor(state) {
      return state.routeColor;
    },

    lineWidth(state) {
      return state.lineWidth;
    },

    activityTitle(state) {
      return state.activityTitle;
    },

    activitySubtitle(state) {
      return state.activitySubtitle;
    }
  },

  actions: {
    createPrintMap(
      context,
      { width = 700, height = 1000, bounds, bearing, pitch, dpi = 300 }
    ) {
      // Calculate pixel ratio
      const actualPixelRatio = window.devicePixelRatio;
      Object.defineProperty(window, 'devicePixelRatio', {
        get: function () {
          return dpi / 96;
        }
      });

      // Create map container
      const hidden = document.createElement('div');
      hidden.className = 'hidden-map';
      document.body.appendChild(hidden);
      const container = document.createElement('div');
      container.style.width = toPixels(width);
      container.style.height = toPixels(height);
      hidden.appendChild(container);

      // Render map
      const renderMap = new mapboxgl.Map({
        container: container,
        style: 'mapbox://styles/gasparrobi/ckw4pehnx62p014o521hhn6hs',
        bearing: bearing,
        pitch: pitch,
        bounds,
        interactive: false,
        preserveDrawingBuffer: true,
        fadeDuration: 0,
        attributionControl: false
      });
      renderMap.on('load', () => {
        context.getters.selectedActivities.forEach((item) => {
          const { id, activity } = item;

          renderMap.addSource(id, {
            type: 'geojson',
            data: activity
          });

          renderMap.addLayer({
            id: id,
            type: 'line',
            source: id,
            layout: {
              'line-join': 'round',
              'line-cap': 'round'
            },
            paint: {
              'line-color': context.getters.routeColor,
              'line-width': context.getters.lineWidth,
              'line-opacity': 0.5
            }
          });
        });
      });
      renderMap.once('idle', function () {
        renderMap.getCanvas().toBlob(function (blob) {
          saveAs(blob, 'map.png');
        });

        renderMap.remove();
        hidden.parentNode.removeChild(hidden);
        Object.defineProperty(window, 'devicePixelRatio', {
          get: function () {
            return actualPixelRatio;
          }
        });
      });
    }
  }
});

store.subscribe((mutation, state) => {
  localStorage.setItem(
    'state',
    typeof state === String ? state : JSON.stringify(state)
  );
});

export default store;
